export interface CrewAllocationFormData {
  id?: string;
  userId: string;
  allocationPercentage: number | null;
}

export interface InstallDateFormData {
  installDateId: string;
  date: string;        // ISO date string 'YYYY-MM-DD' for input[type="date"]
  startTime: string;   // 'HH:mm' or ''
  endTime: string;     // 'HH:mm' or ''
  foremanUserId: string;
  crewAllocations?: CrewAllocationFormData[];
  /** Foreman's own allocation percentage. */
  foremanAllocationPercentage?: number | null;
  isNew?: boolean;
  isAllDay?: boolean;
  hasLaborCosts?: boolean;
  pendingRemoval?: boolean;
  /** Project this calendar pick is attributed to. Set by the parent at pick time
   *  so the panel can route the pick to the correct per-project form. */
  targetProjectId?: string;
}

export type ForemanRole = 'foreman' | 'sub-contractor' | 'co-foreman' | 'field-superintendent';

export interface ForemanOption {
  id: string;
  name: string;
  role: ForemanRole;
}

export interface InstallDateRowSnapshot {
  date: string;
  foremanUserId: string;
  startTime: string;
  endTime: string;
  isAllDay: boolean;
  /** Order-independent fingerprint of all crew allocations (foreman + crew, sorted userId|alloc). */
  crewKey: string;
}

function fullCrewAllocKey(foremanUserId: string, foremanAlloc: number | null | undefined, crewAllocations: CrewAllocationFormData[] | undefined): string {
  const all: CrewAllocationFormData[] = [
    { userId: foremanUserId, allocationPercentage: foremanAlloc ?? null },
    ...(crewAllocations ?? []),
  ];
  return all
    .filter(a => a.userId)
    .map(a => `${a.userId}|${a.allocationPercentage ?? ''}`)
    .sort()
    .join(',');
}

export function snapshotInstallDateRow(
  value: InstallDateFormData,
): InstallDateRowSnapshot {
  const isAllDay = !!value.isAllDay;
  return {
    date: value.date,
    foremanUserId: value.foremanUserId,
    startTime: isAllDay ? '' : value.startTime,
    endTime: isAllDay ? '' : value.endTime,
    isAllDay,
    crewKey: fullCrewAllocKey(value.foremanUserId, value.foremanAllocationPercentage, value.crewAllocations),
  };
}

export function installDateRowsEqual(
  a: InstallDateRowSnapshot,
  b: InstallDateRowSnapshot,
): boolean {
  return a.date === b.date
    && a.foremanUserId === b.foremanUserId
    && a.isAllDay === b.isAllDay
    && a.startTime === b.startTime
    && a.endTime === b.endTime
    && a.crewKey === b.crewKey;
}
